import { Pipe, PipeTransform } from '@angular/core';
import { AnnouncementDto, FileRecordDto } from '@careapp-group/ng-sdk';

/**
 * From an announcement, returns the file that is set as the featured image.
 */
@Pipe({
    name: 'featuredImage',
    pure: true,
    standalone: false
})
export class FeaturedImagePipe implements PipeTransform {
  transform(announcement: AnnouncementDto) {
    // The announcement must have a featured image ID and files.
    if (
      !announcement?.featuredImageId ||
      !announcement?.files ||
      announcement?.files?.length === 0
    ) {
      return;
    }

    // The files must contain a file with an ID that matches the featured id.
    const featuredImage: FileRecordDto = announcement.files.find(
      (file) => file.id === announcement.featuredImageId
    );
    if (featuredImage === undefined || featuredImage === null) {
      return;
    }

    return featuredImage;
  }
}
